import { SLOT_TYPE } from '@/enums';
import i18n from '@/i18n';

export const getSlotTypeTranslation = (id: number) => {
  switch (id) {
    case SLOT_TYPE.IMAGE:
      return i18n.t('photo', { ns: 'common' });
    case SLOT_TYPE.VIDEO:
      return i18n.t('video', { ns: 'common' });
    case SLOT_TYPE.AUDIO:
      return i18n.t('song', { ns: 'common' });
    case SLOT_TYPE.COVER_PHOTO:
      return i18n.t('coverPhoto', { ns: 'common' });
    case SLOT_TYPE.TEXT:
      return i18n.t('text', { ns: 'common' });
    case SLOT_TYPE.TRIBUTE_VIDEO:
      return i18n.t('tributeVideo', { ns: 'common' });
    case SLOT_TYPE.PLAYLIST:
      return i18n.t('playlist', { ns: 'common' });
    case SLOT_TYPE.TEXT_OVERLAY:
      return i18n.t('textOverlay', { ns: 'common' });
    default:
      return '';
  }
};
